'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Segment;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TransportationDetails = require('./TransportationDetails.jsx');

var _TransportationDetails2 = _interopRequireDefault(_TransportationDetails);

var _ServiceDetails = require('./ServiceDetails.jsx');

var _ServiceDetails2 = _interopRequireDefault(_ServiceDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Segment(props) {
  var segment = props.segment;


  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Segment' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(_TransportationDetails2.default, { segment: segment })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(_ServiceDetails2.default, { segment: segment })
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Segment.jsx
// module id = 1482
// module chunks = 0